<div class="savedViews__row" (click)="selectView()">
  <div
    class="savedViews__input-container"
    [ngClass]="{
      'savedViews__input-container--active': ppView.id === selectedViewIds[workspaceId],
    }"
    >
    <div
      class="savedViews__input"
      contenteditable="false"
      #nameInput
      [innerText]="ppView.name"
      (blur)="handleInputBlur($event)"
      (keydown.enter)="handleEnterKeyPress($event)"
      (focus)="setCursorToEnd(nameInput)"
    ></div>

    @if (ppViews.personal.defaultViewId === ppView.id) {
      <div class="savedViews__icon-container">
        <pp-icon
          [ppSrc]="EIconPath.ICON_NAV_TABLE_VIEW_18"
          ppColor="primary-950"
          [ppDisplayContents]="true"
        ></pp-icon>
      </div>
    }

    @if (ppViews.shared.sharedDefaultViewId === ppView.id) {
      <div class="savedViews__icon-container">
        <pp-icon
          [ppSrc]="EIconPath.ICON_NAV_TABLE_VIEW_18"
          [ppColor]="'grey-500'"
          [ppDisplayContents]="true"
        ></pp-icon>
      </div>
    }
  </div>

  <button
    [id]="'savedViewsDrodownBtn' + ppView.id"
    (click)="showDropdown($event, 'savedViewsDrodownBtn' + ppView.id)"
    >
    <pp-icon
      [ppSrc]="EIconPath.ICON_MISC_3_DOTS_MENU_14"
      [ppColor]="'grey-400'"
      [ppDisplayContents]="true"
    ></pp-icon>
  </button>
</div>
